var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlayCircle = function SvgPlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.7 7.667a.5.5 0 0 1 0 .866L7.45 9.832a.5.5 0 0 1-.75-.433V6.8a.5.5 0 0 1 .75-.433z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 3.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M2.5 8a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0",
    clipRule: "evenodd"
  })));
};
export { SvgPlayCircle as ReactComponent };
export default __webpack_public_path__ + "b700067a5ea92d27ef477a309e43c788.svg";